"use client";
import { apiClient } from "@/lib/client";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export async function ConfirmEmail({ confirmation_token }: { confirmation_token: string }) {
  const router = useRouter();

  const handleConfirmEmail = async () => {
    if (confirmation_token) {
      try {
        await apiClient.confirmEmail({ confirmation_token });
      } catch (err) {
        router.push("/signin?email_confirmation=failed");
      }

      router.push("/signin?email_confirmation=success");
    }
  };

  //biome-ignore lint:
  useEffect(() => {
    handleConfirmEmail();
  }, []);

  return null;
}
